const defaultValues = {
  card_holder_name: "",
  card_number: "",
  expiration_date: "",
  security_code: "",
  installments: 1,
};

export default defaultValues;
